import { Buffer } from "buffer";
import { APP_KEY_BLOWFISH, APP_KEY_BLOWFISH2 } from "@ipru-common/constants/SiteConstants";
const Blowfish = require("egoroof-blowfish");

const useBlowFish = (props) => {
  const bfInst = () => new Blowfish(props?.key || APP_KEY_BLOWFISH, Blowfish.MODE.ECB);
  const bfInst2 = () =>
    new Blowfish(props?.key || APP_KEY_BLOWFISH2, Blowfish.MODE.ECB, Blowfish.PADDING.ONE_AND_ZEROS);
  // Make sure that string length is always 8 bit

  const encryptBlowfish = (string) => {
    const bf = bfInst();
    // Encode string
    const encoded = bf.encode(string);
    const hex = Buffer.from(encoded).toString("base64");
    return hex;
  };

  const encryptBlowfishObj = (obj) => {
    const encryptedObj = {};
    // Loop through the object's keys
    for (const k in obj) {
      if (obj?.[k]) {
        const encryptedValue = encryptBlowfish(obj[k]);
        const hex = window.btoa(encryptedValue);
        // Add the encrypted key-value pair to the encrypted object
        encryptedObj[k] = hex;
      }
    }
    return encryptedObj;
  };

  const decryptBlowfish = (string) => {
    const bf = bfInst();
    const base64 = Buffer.from(Buffer.from(window.atob(string)).toString("utf8"), "base64");
    const decoded = bf.decode(base64);
    return decoded;
  };

  const decryptBlowfishQData = (string) => {
    const bf = bfInst2();
    const base64 = Buffer.from(string, "base64");
    const decoded = bf.decode(base64);
    return decoded;
  };

  const simpleDecryptBlowfish = (string) => {
    const bf = bfInst();
    const decoded = bf.decode(string);
    return decoded;
  };

  // FOR PARTNER
  const encryptBlowfishBtoa = (data) => {
    const bf = new Blowfish(props?.key || APP_KEY_BLOWFISH2, Blowfish.MODE.ECB, Blowfish.PADDING.PKCS5);
    var encryptedData = bf.encode(JSON.stringify(data));
    encryptedData = Buffer.from(encryptedData).toString("base64");
    return window.btoa(encryptedData);
  };

  const simpleDecryptBlowfishBase64 = (string) => {
    const bf = bfInst();
    const base64 = Buffer.from(string, "base64");
    const decoded = bf.decode(base64);
    return decoded;
  };

  return {
    encryptBlowfish,
    decryptBlowfish,
    encryptBlowfishObj,
    simpleDecryptBlowfish,
    decryptBlowfishQData,
    encryptBlowfishBtoa,
    simpleDecryptBlowfishBase64,
  };
};

export default useBlowFish;
